import { render, staticRenderFns } from "./PlacasVideo.vue?vue&type=template&id=96abc8e6&"
import script from "./PlacasVideo.vue?vue&type=script&lang=ts&"
export * from "./PlacasVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports